"use client";

import Marquee from "@/components/magicui/marquee";
import Image from "next/image";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useNextSectionScroll } from "@/lib/hooks/use-next-section-scroll";
import { useTranslations } from "@/lib/hooks/use-translations";

// Importiere die Logos direkt
import freeyouLogo from "@/assets/images/freeyou.svg";
import bppsLogo from "@/assets/images/bpps.svg";
import backbaseLogo from "@/assets/images/Logo-backbase.svg";
import hsbcLogo from "@/assets/images/HSBC_logo.svg";
import compavoLogo from "@/assets/images/compavo.png";

const logos = [
  {
    name: "Freeyou",
    src: freeyouLogo,
    width: 128,
    height: 40,
  },
  {
    name: "BPPS",
    src: bppsLogo,
    width: 128,
    height: 40,
  },
  {
    name: "Backbase",
    src: backbaseLogo,
    width: 128,
    height: 40,
  },
  {
    name: "HSBC",
    src: hsbcLogo,
    width: 128,
    height: 40,
  },
  {
    name: "Compavo",
    src: compavoLogo,
    width: 128,
    height: 40,
  }
];

export default function Logos() {
  const handleNextSection = useNextSectionScroll("logos");
  const { t } = useTranslations();
  
  return (
    <section id="logos">
      <div className="container mx-auto px-6 py-12">
        <h2 className="text-sm text-primary font-mono font-medium tracking-wider uppercase text-center">
          {t('pages.home.logos.title')}
        </h2>
        <div className="relative mt-6">
          <Marquee className="max-w-full [--duration:20s]">
            {logos.map((logo, idx) => (
              <Image
                key={idx}
                width={logo.width}
                height={logo.height}
                src={logo.src}
                className="h-10 w-32 dark:brightness-0 dark:invert"
                alt={logo.name}
              />
            ))}
          </Marquee>
          <div className="pointer-events-none absolute inset-y-0 left-0 h-full w-1/3 bg-gradient-to-r from-background"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 h-full w-1/3 bg-gradient-to-l from-background"></div>
        </div>
      </div>
    </section>
  );
}
